import Service from "@ember/service"
import { tracked } from "@glimmer/tracking"

export default class HeadData extends Service {
  /**
   * Field that stores <meta name="robots"> content.
   * Rendered by application.hbs and set in routes' model() function.
   */
  @tracked robots: string = "all"
}
